import React from 'react';

export function Loading(props) {
  let loadingClass = 'loading';
  return (
    <div className={loadingClass}>
      <div className="spinner">
        <div className="cube1"/>
        <div className="cube2"/>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/parts/Loading.jsx